import { useRequest } from "domain/core/hooks/useRequest"
import { TApiDictionaryRes } from "../types"

export const useFetchDictionary = (url: string): TApiDictionaryRes => {
  const { data, isLoading, error } = useRequest({
    url,
    sendOnStart: true,
  })

  return {
    isLoading: isLoading || data?.list === undefined,
    data: data?.list,
    error,
  }
}
